export default __webpack_public_path__ + "ids.97e64c19683f421a52ef.svg";